module.exports = __webpack_public_path__ + "static/media/houston.25169a50.webp";